<script setup lang="ts">
import { ExclamationIcon } from '@heroicons/vue/outline';
import { useI18n } from 'vue-i18n';
import AtTopBar from '@/components/atoms/AtTopBar.vue';

const { t } = useI18n();
</script>

<template>
  <AtTopBar
    :isShown="true"
    class="items-center gap-2 bg-amber-400 p-3 text-sm text-gray-900"
  >
    <ExclamationIcon class="h-5 w-5 shrink-0" />
    <p>
      {{
        t(
          'Codio is now in read-only mode. For questions, contact {email}',
          { email: 'support@codioimpact.com' },
        )
      }}
    </p>
  </AtTopBar>
</template>
